import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllBusinessAddressesApi,
  getAllCustomerSupplierApi,
  addBusinessAddressApi,
  addCustomerSupplierApi,
  editBusinessAddressApi,
  editCustomerSupplierApi,
  getAllLedgersListApi,
  addLegerApi,
  updateLedgerApi,
  checkUniqueLedgerApi,
  getAllExpensesLedgersListApi,
  getAllIncomeLedgersListApi,
  getAllTypesLedgerListApi,
  getAllTypesWithTaxListApi,
  checkUniqueLegalCustomerSupplierNameApi,
  getSingleTypeLedgerListApi,
  getAllStocksGroupListApi,
  addStockGroupApi,
  updateStockGroupApi,
  parentStockGroupApi,
  getAllStockItemListApi,
  getAllUnitMeasurementListApi,
  addAllUnitMeasurementListApi,
  updateAllUnitMeasurementListApi,
  addStockItemListApi,
  updateStockItemListApi,
  checkUniqueSkuNumberApi,
  getSingleCustomerSupplierApi,
  getDepartmentListApi,
  createDepartmentApi,
  updateDepartmentApi,
  checkUniqueDepartmentNameApi,
  getSingleBusinessAddressApi,
  getSingleStockItemApi,
  getMultipleStockItemQuantityApi,
  changeCustomerSupplierStatusApi,
  createMappedPdfTemplateApi,
  getMappedPdfTemplateApi,
  multipleUploadFilesApi,
  StockItemBulkUploadApi,
  addTurnOverHSNCheckApi,
  updateTurnOverHSNCheckApi,
  getHsnCheckApi,
  addHsnCheckWarningApi,
  customerSupplierBulkUploadApi,
  getBatchManagementApi,
  addBatchManagementApi,
  updateBatchManagementApi,
  getSingleBatchManagementApi,
  changeBatchStatusApi,
  checkUniqueBatchNumberApi,
  addAutoUniqueNumberGenerationApi,
  getAutoUniqueNumberGenerationCheckApi,
  getStockMappedBatchListApi,
  getCustomerSupplierGroupingListApi,
} from "../../apis/clientSettingApis";
import {
  AddBusinessAddressPayloadType,
  AddCustomerSupplierPayloadType,
  AddLedgerPayloadType,
  EditBusinessAddressPayloadType,
  EditCustomerSupplierPayloadType,
  CheckUniqueLedgerPayloadType,
  GetAllLedgersListPayloadType,
  UpdateLedgerPayloadType,
  GetAllBussinessAddressesListPayloadType,
  GetAllCustomerSupplierListPayloadType,
  CheckUniqueLegalCustomerSupplierNamePayloadType,
  GetAllUnitMeasurementListPayloadType,
  AddUnitMeasurementListPayloadType,
  UpdateUnitsMeasermentPayloadType,
  AddStockItemPayloadType,
  GetAllStocksGroupPayloadType,
  AddStockGroupPayloadType,
  UpdateStockGroupPayloadType,
  getAllTypesParentStockGroupType,
  GetAllStockItemListPayloadType,
  UpdateStockItemListPayloadType,
  CheckUniqueSkuNumberPayloadType,
  GetSingleCustomerSupplierListPayloadType,
  GetDepartmentListPayloadType,
  CreateDepartmentPayloadType,
  UpdateDepartmentPayloadType,
  UniqueDepartmentNamePayloadType,
  GetSingleStockItemListPayloadType,
  StockItemQuantityRatePayloadType,
  StockMultipleItemQuantityRatePayloadType,
  ChangeStatusCustomerSupplierPayloadType,
  AddPdfMappingTemplatePayloadType,
  GetPdfMappingTemplatePayloadType,
  StockUploadFilePayloadType,
  AddTurnOverHSNCheckPayloadType,
  UpdateTurnOverHSNCheckPayloadType,
  GetHSNCheckPayloadType,
  AddHSNCheckWarningPayloadType,
  CustomerSupplierBulkUploadType,
  CheckUniqueBatchNumberPayloadType,
  AddBatchPayloadType,
  UpdateBatchPayloadType,
  GetBatchListPayloadType,
  GetSingleBatchListPayloadType,
  ChangeStatusBatchListPayloadType,
  AddAutoUniqueNumberPayloadType,
  GetAutoUniqueNumberPayloadType,
  GetStockMappedBatchListPayloadType,
  GetCustomerSupplierGroupingListPayloadType,
} from "../../commonTypes/clientSettingsTypes";
import { UploadFilePayloadType } from "../../commonTypes/stcoToolsType";
import { StockItemBulkUpload } from "../../screens";


/* Customer/Supplier Module */
export const getAllCustomerSupplierAction = createAsyncThunk(
  "clientSettings/getAllCustomerList",
  async (data: GetAllCustomerSupplierListPayloadType) => {
    const response = await getAllCustomerSupplierApi(data);
    return response.data;
  }
);

export const getSingleCustomerSupplierAction = createAsyncThunk(
  "clientSettings/getSingleCustomerList",
  async (data: GetSingleCustomerSupplierListPayloadType) => {
    const response = await getSingleCustomerSupplierApi(data);
    return response.data;
  }
);

export const addCustomerSupplierAction = createAsyncThunk(
  "clientSettings/addCustomerSupplier",
  async (data: AddCustomerSupplierPayloadType) => {
    const response = await addCustomerSupplierApi(data);
    return response.data;
  }
);

export const editCustomerSupplierAction = createAsyncThunk(
  "clientSettings/editCustomerSupplier",
  async (data: EditCustomerSupplierPayloadType) => {
    const response = await editCustomerSupplierApi(data);
    return response.data;
  }
);

export const changeCustomerSupplierStatusAction = createAsyncThunk(
  "clientSettings/changeStatusCustomerSupplier",
  async (data: ChangeStatusCustomerSupplierPayloadType) => {
    const response = await changeCustomerSupplierStatusApi(data);
    return response.data;
  }
);

// Bulk Upload Customer Supplier

export const customerSupplierBulkUploadDataAction = createAsyncThunk(
  "clientSettings/bulkUploadCustomerSupplier",
  async (data: CustomerSupplierBulkUploadType) => {
    const response = await customerSupplierBulkUploadApi(data);
    return response.data;
  }
);


/* Business Address Module */
export const getAllBusinessAddressAction = createAsyncThunk(
  "clientSettings/getAllBusinessAddress",
  async (data: GetAllBussinessAddressesListPayloadType) => {
    const response = await getAllBusinessAddressesApi(data);
    return response.data;
  }
);

export const addBusinessAddressAction = createAsyncThunk(
  "clientSettings/addBusinessAddress",
  async (data: AddBusinessAddressPayloadType) => {
    const response = await addBusinessAddressApi(data);
    return response.data;
  }
);

export const editBusinessAddressAction = createAsyncThunk(
  "clientSettings/editBusinssAddress",
  async (data: EditBusinessAddressPayloadType) => {
    const response = await editBusinessAddressApi(data);
    return response.data;
  }
);

export const getSingleBusinessAddressAction = createAsyncThunk(
  "clientSettings/getSingleBusinssAddress",
  async (data: any) => {
    const response = await getSingleBusinessAddressApi(data);
    return response.data;
  }
);

/* Accounts Manager Module */
export const getAllLedgersListAction = createAsyncThunk(
  "clientSettings/getAllLedgersList",
  async (data: any) => {
    const response = await getAllLedgersListApi(data);
    return response.data;
  }
);

export const getAllExpensesLedgersListAction = createAsyncThunk(
  "clientSettings/getAllExpensesLedgersList",
  async (data: GetAllLedgersListPayloadType) => {
    const response = await getAllExpensesLedgersListApi(data);
    return response.data;
  }
);

export const getAllIncomeLedgersListAction = createAsyncThunk(
  "clientSettings/getAllExpensesLedgersList",
  async (data: GetAllLedgersListPayloadType) => {
    const response = await getAllIncomeLedgersListApi(data);
    return response.data;
  }
);

export const addLedgerAction = createAsyncThunk(
  "clientSettings/addLedger",
  async (data: AddLedgerPayloadType) => {
    const response = await addLegerApi(data);
    return response.data;
  }
);

export const updateLedgerAction = createAsyncThunk(
  "clientSettings/editLedger",
  async (data: UpdateLedgerPayloadType) => {
    const response = await updateLedgerApi(data);
    return response.data;
  }
);

export const checkUniqueLedgerAction = createAsyncThunk(
  "clientSettings/checkUniqueLedger",
  async (data: CheckUniqueLedgerPayloadType) => {
    const response = await checkUniqueLedgerApi(data);
    return response.data;
  }
);

export const getSingleTypeLedgerListAction = createAsyncThunk(
  "clientSettings/singleTypeLedgerList",
  async (data: GetAllLedgersListPayloadType) => {
    const response = await getSingleTypeLedgerListApi(data);
    return response.data;
  }
);

export const getAllTypesLedgerListAction = createAsyncThunk(
  "clientSettings/getAllTypesLedgerList",
  async (data: GetAllLedgersListPayloadType) => {
    const response = await getAllTypesLedgerListApi(data);
    return response.data;
  }
);

export const getAllTypesWithTaxListAction = createAsyncThunk(
  "clientSettings/getAllTypesWithTaxList",
  async (data: GetAllLedgersListPayloadType) => {
    const response = await getAllTypesWithTaxListApi(data);
    return response.data;
  }
);

export const checkUniqueLegalCustomerSupplierAction = createAsyncThunk(
  "clientSettings/checkUniqueLegalCustomerSupplierName",
  async (data: CheckUniqueLegalCustomerSupplierNamePayloadType) => {
    const response = await checkUniqueLegalCustomerSupplierNameApi(data);
    return response.data;
  }
);

/* Stock Manager Module */

export const getAllUnitMeasurementListAction = createAsyncThunk(
  "clientSettings/getAllUnitMeasurementList",
  async (data: GetAllUnitMeasurementListPayloadType) => {
    const response = await getAllUnitMeasurementListApi(data);

    return response.data;
  }
);

export const getSingleStockItemDataAction = createAsyncThunk(
  "clientSettings/getSingleStockItemData",
  async (data: GetSingleStockItemListPayloadType) => {
    const response = await getSingleStockItemApi(data);

    return response.data;
  }
);

export const getAllTypesStocksGroupAction = createAsyncThunk(
  "clientSettings/getAllTypesStocksGroupList",
  async (data: GetAllStocksGroupPayloadType) => {
    const response = await getAllStocksGroupListApi(data);
    return response.data;
  });

export const addUnitMeasurementListAction = createAsyncThunk(
  "clientSettings/addUnitMeasurementListAction",
  async (data: AddUnitMeasurementListPayloadType) => {
    const response = await addAllUnitMeasurementListApi(data);
    return response.data;
  }
);

export const addStockGrouopAction = createAsyncThunk(
  "clientSettings/addStockGroup",
  async (data: AddStockGroupPayloadType) => {
    const response = await addStockGroupApi(data);
    return response.data;
  });

export const updateUnitsMeasermentAction = createAsyncThunk(
  "clientSettings/editUnitMeaserment",
  async (data: UpdateUnitsMeasermentPayloadType) => {
    const response = await updateAllUnitMeasurementListApi(data);
    return response.data;
  }
);

export const addStockItemAction = createAsyncThunk(
  "clientSetting/addStockItem",
  async (data: AddStockItemPayloadType) => {
    const response = await addStockItemListApi(data)
    return response.data;
  }
);
export const updateStockItemAction = createAsyncThunk(
  "clientSetting/updateStockItem",
  async (data: UpdateStockItemListPayloadType) => {
    const response = await updateStockItemListApi(data)
    
    return response.data;
  }
);

export const checkUniqueSkuNumberAction = createAsyncThunk(
  "clientSettings/checkUniqueSkuNumber",
  async (data: CheckUniqueSkuNumberPayloadType) => {
    const response = await checkUniqueSkuNumberApi(data);
    return response.data;
  }
);

export const getAllStockItemListAction = createAsyncThunk(
  "clientSettings/getAllStockItem",
  async (data: GetAllStockItemListPayloadType) => {
    const response = await getAllStockItemListApi(data)
    return response.data;
  }
);

export const updateStockGroupAction = createAsyncThunk(
  "clientSettings/editStockGroup",
  async (data: UpdateStockGroupPayloadType) => {
    const response = await updateStockGroupApi(data);
    return response.data;
  }
);

export const getAllTypesParentStockGroupAction = createAsyncThunk(
  "clientSettings/parentStockGroup",
  async (data: getAllTypesParentStockGroupType) => {
    const response = await parentStockGroupApi(data);
    return response.data;
  }
);

export const getDepartmentListAction = createAsyncThunk(
  "clientSettings/getDepartment",
  async (data: GetDepartmentListPayloadType) => {
    const response = await getDepartmentListApi(data)
    return response.data;
  }
);
export const checkUniqueDepartmentNameAction=createAsyncThunk(
  "clientSettings/checkUniqueDepartmentName",
  async(data:UniqueDepartmentNamePayloadType)=>{
    const response = await checkUniqueDepartmentNameApi(data);
    return response;
  }
  )

export const createDepartmentAction = createAsyncThunk(
  "clientSettings/createDepartment",
  async (data: CreateDepartmentPayloadType) => {
    const response = await createDepartmentApi( data);
    return response.data;
  }
);

export const updateDepartmentAction = createAsyncThunk(
  "clientSettings/updateDepartment",
  async (data: UpdateDepartmentPayloadType) => {
    const response = await updateDepartmentApi(data);
    return response.data;
  }
);


export const getMultipleStockItemQuantityAction= createAsyncThunk(
  "clientSettings/getMultipleStockItemQuantity",
  async (data: StockMultipleItemQuantityRatePayloadType) => {
    const response = await getMultipleStockItemQuantityApi(data);
    return response.data;
  }
);

export const createMappedPdfTemplateAction = createAsyncThunk(
  "clientSettings/createMappedPdfTemplate",
  async (data: AddPdfMappingTemplatePayloadType) => {
    const response = await createMappedPdfTemplateApi( data);
    return response.data;
  }
);


export const getMappedPdfTemplateAction= createAsyncThunk(
  "clientSettings/getMappedPdfTemplate",
  async (data: GetPdfMappingTemplatePayloadType) => {
    const response = await getMappedPdfTemplateApi(data);
    return response.data;
  }
);

// stock file upload
export const multipleUploadFilesAction = createAsyncThunk(
  "stcoTools/fileUpload",
  async (files: StockUploadFilePayloadType) => {
    const response = await multipleUploadFilesApi(files);
    return response.data;
  }
);
// bulk upload
 export const stockItemBulkUploadDataAction = createAsyncThunk(
  "bulkUpload/stockItems", async (data: any) => {
    const response = await StockItemBulkUploadApi(data);
    return response.data;
  }
 )


 export const addTurnOverHSNCheckAction = createAsyncThunk(
  "clientSettings/addTurnOverHSNCheck",
  async (data: AddTurnOverHSNCheckPayloadType) => {
    const response = await addTurnOverHSNCheckApi( data);
    return response.data;
  }
);

export const updateTurnOverHSNCheckAction = createAsyncThunk(
  "clientSettings/updateTurnOverHSNCheck",
  async (data: UpdateTurnOverHSNCheckPayloadType) => {
    const response = await updateTurnOverHSNCheckApi( data);
    return response.data;
  }
);


export const getHsnCheckAction= createAsyncThunk(
  "clientSettings/getHsnCheck",
  async (data: GetHSNCheckPayloadType) => {
    const response = await getHsnCheckApi(data);
    return response.data;
  }
);


export const addHsnCheckWarningAction = createAsyncThunk(
  "clientSettings/addHsnCheckWarning",
  async (data: AddHSNCheckWarningPayloadType) => {
    const response = await addHsnCheckWarningApi( data);
    return response.data;
  }
);


// batch mangemnent
export const addBatchManagementAction = createAsyncThunk(
  "clientSettings/addManagementBatch",
  async (data: AddBatchPayloadType) => {
    const response = await addBatchManagementApi( data);
    return response.data;
  }
);

export const updateBatchManagementAction = createAsyncThunk(
  "clientSettings/updateManagementBatch",
  async (data: UpdateBatchPayloadType) => {
    const response = await updateBatchManagementApi( data);
    return response.data;
  }
);

export const getBatchManagementAction= createAsyncThunk(
  "clientSettings/getManagementBatch",
  async (data: GetBatchListPayloadType) => {
    const response = await getBatchManagementApi(data);
    return response.data;
  }
);

export const getSingleBatchManagementAction = createAsyncThunk(
  "clientSettings/getSingleManagementBatch",
  async (data: GetSingleBatchListPayloadType) => {
    const response = await getSingleBatchManagementApi(data);
    return response.data;
  }
);


export const changeBatchStatusAction = createAsyncThunk(
  "clientSettings/changeStatusBatch",
  async (data: ChangeStatusBatchListPayloadType) => {
    const response = await changeBatchStatusApi(data);
    return response.data;
  }
);

export const checkUniqueBatchNumberAction = createAsyncThunk(
  "clientSettings/checkUniqueBatchNumber",
  async (data: CheckUniqueBatchNumberPayloadType) => {
    const response = await checkUniqueBatchNumberApi(data);
    return response.data;
  }
);

//Add Auto Unique Number Generation
 
export const addAutoUniqueNumberGenerationAction = createAsyncThunk(
  "auth/addAutoUniqueNumber",
  async (data: AddAutoUniqueNumberPayloadType) => {
    const response = await addAutoUniqueNumberGenerationApi(data);
    return response.data;
  }
);
 
// Get Auto Unique Number Generation Check
 
export const getAutoUniqueNumberGenerationAction = createAsyncThunk(
  "auth/getAutoUniqueNumber",
  async (data: GetAutoUniqueNumberPayloadType) => {
    const response = await getAutoUniqueNumberGenerationCheckApi(data);
    return response.data;
  }
);


export const getStockMappedBatchListAction= createAsyncThunk(
  "clientSettings/getStockMappedBatchList",
  async (data: GetStockMappedBatchListPayloadType) => {
    const response = await getStockMappedBatchListApi(data);
    return response.data;
  }
);

// customer supplier grouping

export const getCustomerSupplierGroupingListAction = createAsyncThunk(
  "clientSettings/customerSupplierGroupingList",
  async (data: GetCustomerSupplierGroupingListPayloadType) => {
    const response = await getCustomerSupplierGroupingListApi(data);
    return response.data;
  }
);